<script>
  import { onMount } from "svelte"
  import { user } from "../../stores/User"
  import { BASE_URL } from "../../stores/BASE_URL"
  import { navigate } from "svelte-routing"
  import SinInformacion from "../../components/Sin_informacion.svelte"
  import Spinner from "../../components/Spinner.svelte"

  export let ruc
  export let documento = ""

  let data = {
    empresa: null,
    loading: true,
  }

  let montado = false
  let controller
  let error = ""

  const cargarDatos = async (rucConsulta, documentoConsulta, sessionKey) => {
    controller?.abort()
    const actual = new AbortController()
    controller = actual
    data = { empresa: null, loading: true }
    error = ""
    const query = new URLSearchParams({
      ruc: rucConsulta,
      session_key: sessionKey,
      ops: documentoConsulta ? "adicional_empresa_general_datos" : "general_datos",
    })
    if (documentoConsulta) query.set("documento", documentoConsulta)

    try {
      const response = await fetch(`${BASE_URL}${documentoConsulta ? "persona.php" : "empresa.php"}?${query}`, { signal: actual.signal })
      const resp = await response.json()
      if (actual.signal.aborted) return
      if (resp.status === "error" || resp.data?.error_id !== undefined) {
        if (String(resp.data?.error_id) === "405") navigate("/", { replace: true })
        throw new Error(resp.data?.message || "No se pudo cargar la información de la empresa.")
      }
      if (!response.ok) throw new Error("No se pudo consultar la empresa.")
      const empresa = Array.isArray(resp.data) ? resp.data[0] : resp.data
      data.empresa = empresa && typeof empresa === "object" && (empresa.ruc || empresa.razonsocial) ? empresa : null
    } catch (err) {
      if (!actual.signal.aborted) error = err.message || "No se pudo cargar la información de la empresa."
    } finally {
      if (!actual.signal.aborted) data.loading = false
    }
  }

  $: if (montado && ruc) cargarDatos(ruc, documento, $user.session_key)

  onMount(() => {
    montado = true
    return () => {
      montado = false
      controller?.abort()
    }
  })
</script>

{#if data.loading === true}
  <Spinner />
{:else if error}
  <div class="alert theme-danger" role="alert">
    {error}
    <button type="button" class="btn btn-sm btn-outline theme-danger ms-3" on:click={() => cargarDatos(ruc, documento, $user.session_key)}>Reintentar</button>
  </div>
{:else if !data.empresa}
  <SinInformacion />
{:else}
  <div class="table-responsive">
    <table class="table table-striped table-sm">
      <tbody>
        <tr>
          <th class="fg-secondary fw-normal">RUC</th>
          <td colspan="3">{data.empresa.ruc}</td>
        </tr>
        <tr>
          <th class="fg-secondary fw-normal">Razón social</th>
          <td colspan="3">{data.empresa.razonsocial}</td>
        </tr>
        <tr>
          <th class="fg-secondary fw-normal">Comercial</th>
          <td colspan="3">{data.empresa.nombrecomercial}</td>
        </tr>
        <tr>
          <th class="fg-secondary fw-normal">Tipo</th>
          <td colspan="3">{data.empresa.tipo}</td>
        </tr>
        <tr>
          <th class="fg-secondary fw-normal">Giro</th>
          <td colspan="3">{data.empresa.giro}</td>
        </tr>
        <tr>
          <th class="fg-secondary fw-normal">Fecha Inscripción</th>
          <td colspan="3">{data.empresa.fecha_inscripcion}</td>
        </tr>
        <tr>
          <th class="fg-secondary fw-normal">Fecha Inicio</th>
          <td>{data.empresa.fecha_inicio}</td>
          <th class="fg-secondary fw-normal">Fecha Baja</th>
          <td>{data.empresa.fecha_baja}</td>
        </tr>
        <tr>
          <th class="fg-secondary fw-normal">Estado</th>
          <td>{data.empresa.estado}</td>
          <th class="fg-secondary fw-normal">Condición</th>
          <td>{data.empresa.condicion}</td>
        </tr>
        <tr>
          <th class="fg-secondary fw-normal">Comercio Exterior</th>
          <td colspan="3">{data.empresa.comercio}</td>
        </tr>
        <tr>
          <th class="fg-secondary fw-normal">Fecha de actualización</th>
          <td colspan="3">{data.empresa.fecha_consulta}</td>
        </tr>
      </tbody>
    </table>
  </div>
{/if}
